export const GYM_TYPES = [
  { value: "24_7_general", label: "24/7 general gym" },
  { value: "full_service", label: "Full-service gym" },
  { value: "premium_health_club", label: "Premium health club" },
  { value: "boutique_fitness", label: "Boutique fitness studio" },
  { value: "crossfit_functional", label: "CrossFit or functional training" },
  { value: "pilates_yoga", label: "Pilates or yoga studio" },
  { value: "personal_training", label: "Personal-training studio" },
  { value: "other", label: "Other" },
];

export const MANAGER_INCLUDED = [
  { value: "yes_operates_without_owner", label: "Yes — the gym operates without the owner" },
  { value: "partial", label: "Partly — the owner is still actively involved" },
  { value: "owner_manages", label: "No — the owner manages the gym" },
];

export const FOUR_WEEK_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "partly", label: "Partly" },
  { value: "no", label: "No" },
];

export const FINANCIAL_RECORDS = [
  { value: "accountant_prepared", label: "Accountant-prepared financial statements" },
  { value: "bookkeeping_tax", label: "Bookkeeping records and tax returns" },
  { value: "basic_internal", label: "Basic internal records" },
  { value: "incomplete", label: "Incomplete or mixed personal and business records" },
];

export const LEASE_TENURE = [
  { value: "over_5", label: "More than five years" },
  { value: "3_to_5", label: "Three to five years" },
  { value: "1_to_3", label: "One to three years" },
  { value: "under_1_or_uncertain", label: "Less than one year or uncertain" },
];

export const EQUIPMENT_LEVELS = [
  {
    value: "premium",
    label: "Premium commercial",
    description:
      "High-quality commercial equipment (Technogym, Life Fitness, Hammer Strength, Precor, Matrix, Gym80, Panatta, Eleiko, Watson, Rogue commercial, AlphaFit premium, Concept2).",
  },
  {
    value: "standard",
    label: "Standard commercial",
    description:
      "Commercial-grade equipment suitable for an independent gym or studio (Verve, Force USA, ATX, Impulse, SportsArt, Australian Barbell, AlphaFit standard, Body-Solid commercial, mixed premium/mid).",
  },
  {
    value: "basic",
    label: "Basic or light-commercial",
    description:
      "Entry-level, light-commercial or home-grade equipment (Bodyworx, Cortex, Fortis, Everfit, entry-level house brands, generic imports).",
  },
];

export const EQUIPMENT_CONDITIONS = [
  { value: "excellent", label: "Excellent" },
  { value: "good", label: "Good" },
  { value: "average", label: "Average" },
  { value: "poor", label: "Poor" },
  { value: "significant_replacement", label: "Requires significant replacement" },
];

export const WORKING_OWNERS = [
  { value: 1, label: "One" },
  { value: 2, label: "Two" },
  { value: 3, label: "Three or more" },
];

export const STATES = [
  "NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT",
];

export const SELLING_TIMEFRAMES = [
  { value: "immediately", label: "Immediately" },
  { value: "within_6_months", label: "Within 6 months" },
  { value: "within_12_months", label: "Within 12 months" },
  { value: "not_currently_selling", label: "Not currently selling (curious about value)" },
];
